import { render, staticRenderFns } from "./home-user.vue?vue&type=template&id=3190a126&scoped=true"
var script = {}
import style0 from "./home-user.vue?vue&type=style&index=0&id=3190a126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3190a126",
  null
  
)

export default component.exports